const PRESET_RANK = { LOW: 1, MID: 2, HIGH: 3 };

export function presetLevelFromName(name) {
  const n = (name || '').trim().toLowerCase();
  if (n.endsWith(' high') || n === 'high') return 'HIGH';
  if (n.endsWith(' mid') || n === 'mid') return 'MID';
  return 'LOW';
}

export function maxPresetLevel(user) {
  const level = (user?.max_preset_level || '').toUpperCase();
  if (PRESET_RANK[level]) return level;
  if ((user?.tier || '').toUpperCase() === 'FREE' && user?.role !== 'SUPERADMIN') {
    return 'LOW';
  }
  return 'HIGH';
}

export function canUseDesigner(user) {
  if (!user) return false;
  if (user.role === 'SUPERADMIN') return true;
  if (user.agent_designer_access === false) return false;
  if (user.agent_designer_access === true) return true;
  return (user.tier || '').toUpperCase() !== 'FREE';
}

export function isPresetLocked(preset, user) {
  if (!preset) return false;
  if (preset.locked === true) return true;
  if (preset.locked === false) return false;
  if (user?.role === 'SUPERADMIN') return false;
  const level = presetLevelFromName(preset.name);
  return PRESET_RANK[level] > PRESET_RANK[maxPresetLevel(user)];
}
